var _title, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhySearch = function SvgWhySearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Magnifying glass with person icon")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.138 42 51 46.863l-4.314 4.314-4.862-4.863"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8481E2",
    stroke: "#000",
    strokeWidth: 1.4,
    d: "M26.376 1.95c13.486 0 24.419 10.935 24.419 24.423s-10.933 24.422-24.42 24.422c-13.486 0-24.418-10.934-24.418-24.422S12.889 1.95 26.376 1.95Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.4,
    d: "M39.386 39.39c-7.179 7.179-18.825 7.174-26.012-.014-7.186-7.188-7.191-18.835-.013-26.015 7.18-7.18 18.825-7.175 26.012.013s7.192 18.835.013 26.015Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9D0B4",
    stroke: "#000",
    strokeWidth: 1.4,
    d: "M26.374 27.932a6.87 6.87 0 0 1-6.87-6.87 6.87 6.87 0 1 1 6.87 6.87Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#70D6F9",
    stroke: "#000",
    strokeWidth: 1.4,
    d: "M34.904 42.687a18.44 18.44 0 0 1-17.06-.018V35.2c0-1.007.816-1.824 1.823-1.824H33.08c1.006 0 1.823.817 1.823 1.824z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD89E",
    stroke: "#000",
    strokeWidth: 1.4,
    d: "m55.317 49.036-6.285 6.286 5.426 5.426a4.444 4.444 0 0 0 6.284 0zm0 0 5.425 5.427a4.445 4.445 0 0 1 0 6.285z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9BC6FF",
    stroke: "#000",
    strokeWidth: 1.4,
    d: "m45.397 51.687 6.285-6.286 2.645 2.645-6.285 6.286z"
  })));
};
export default SvgWhySearch;